import React, { memo } from "react";
import ActivityIcon from "./common/ActivityIcon";
import LoadingActivitiesAndBooked from "./common/LoadingActivitiesAndBooked";
import {
	getActivityDescription,
	getActivityDisplayName,
} from "../general/activitiesTags";

const AvailableActivitiesAndBooked = memo(({
	                                           loading,
	                                           day,
	                                           formattedSelectedDay,
	                                           activitiesTags,
	                                           activities,
	                                           bookings,
	                                           openActivityModal,
	                                           user,	
	                                           lang
                                           }) => {
	
	const renderAvailableActivities = () => {
		return activities.length > 0 && activities.map((activity) => {
			const activityTag = activitiesTags.find(tag => tag.id === activity.activity.tags[0]);
			const icon = activityTag?.icon;
			const displayName = getActivityDisplayName(activityTag, activity, lang);
			const tagDescription = getActivityDescription(activityTag, activity, lang);
			const iconMui = activityTag?.iconMui;
			const color = activityTag?.color;
			const occurrenceYmd = activity?.start?.slice(0, 10) ?? "";
			const bookedEvent = bookings.filter(book =>
				book.activityId === activity.activityId &&
				book.info.some(i => i.date === occurrenceYmd && i.bookings.length > 0)
			) || [];
			
			return (
				<div key={activity.id}
				     className="grid grid-cols-3 gap-0 p-4 relative transition-all duration-400 ease-linear">
					
					{/* LEFT SIDE: My Events */}
					{!user?.isTestUser && (
						<div className="text-center flex justify-end">
							{bookedEvent.length > 0 && (
								<button
									onClick={() =>
										openActivityModal(
											{ ...activity, activityName: displayName, tagDescription },
											"delete",
										)
									}
									className="flex justify-center"
								>
									<div className="flex items-center mt-4">
										<div className="text-sm">
											<div className="text-end font-semibold">{displayName}</div>
											<div className="text-end">{activity?.start?.slice(11, 16)}</div>
										</div>
										<div
											style={{ backgroundColor: color }}
											className="cursor-pointer mx-1 p-1 border-2 border-gray-800 rounded-full"
										>
											<ActivityIcon iconMui={iconMui} icon={icon} />
										</div>
									</div>
								</button>
							)}
						</div>
					)}
					
					{/* MIDDLE LINE */}
					{!user?.isTestUser && (
						<div className="text-center flex items-center">
							<div
								className={`transform ${bookedEvent.length > 0 ? "-translate-x-1/2" : "translate-x-1/2"} border-b border-2 border-black border-solid w-1/6 mx-auto mt-6 transition-all duration-400 ease-in-out`}></div>
							<div
								className="absolute top-0 bottom-0 left-1/2 transform -translate-x-1/2 border-2 border-black border-r border-solid"></div>
						</div>
					)}
					
					{/* RIGHT SIDE: Activities */}
					<div className={`text-center ${user?.isTestUser ? "col-span-3" : ""}`}>
						{bookedEvent.length === 0 && (
							<button
								onClick={() =>
									openActivityModal(
										{ ...activity, activityName: displayName, tagDescription },
										"book",
									)
								}
								className="flex justify-center items-start"
							>
								<div className="flex items-center mt-4">
									<div
										style={{ backgroundColor: color }}
										className="cursor-pointer mx-1 p-1 border-2 border-gray-800 rounded-full"
									>
										<ActivityIcon iconMui={iconMui} icon={icon} />
									</div>
									<div className="text-sm">
										<div className="text-start font-semibold">{displayName}</div>
										<div className="text-start">
											{activity?.start?.slice(11, 16) || ""}
										</div>
										{activity?.activity?.locationName?.text && (
											<div className="text-start italic">{activity.activity.locationName.text}</div>
										)}
									</div>
								</div>
							</button>
						)}
					</div>
				</div>
			);
		});
	};
	
	return (
		<>
			{/* HEADER */}
			<div className="flex justify-between items-start mb-2">
				{!user?.isTestUser ? (
					<>
						<div className="w-2/5">
							<h2 className="text-sm font-normal text-center">My Events</h2>
						</div>
						<div className="w-1/5">
							<div className="flex w-16 justify-center items-center text-center">
								<div className="uppercase font-bold text-xl pr-2">{day?.split(" ")[0]}</div>
								<div className="font-bold text-xl">{day?.split(" ")[1]}</div>
							</div>
						</div>
						<div className="w-2/5">
							<h2 className="text-sm font-normal text-center">Activities</h2>
						</div>
					</>
				) : (
					<div className="w-full flex justify-center items-center">
						<div className="flex justify-center items-center text-center">
							<div className="uppercase font-bold text-xl pr-2">{day?.split(" ")[0]}</div>
							<div className="font-bold text-xl">{day?.split(" ")[1]}</div>
						</div>
					</div>
				)}
			</div>
			
			{/* BODY */}
			<div className="flex justify-between m-2 whitespace-normal mb-16">
				<div className="w-full">
					{loading ? <LoadingActivitiesAndBooked /> : renderAvailableActivities()}
				</div>
			</div>
		</>
	);
});

export default AvailableActivitiesAndBooked;
